// API/ UserAPI.js

import { api } from "../Component/Configuration/ApiConfig";

const userApi = {

  getUserList: async () => {
    try {
      const response = await api.get('/User/GetUsersList');
      console.log(response);
      const { status, resultData } = response.data;

      if (status) {
        return resultData;
      } else {
        console.error('Failed to fetch user list');
        return [];
      }
    } catch (error) {
      console.error('Error fetching user list:', error.message);
      return [];
    }
  },

  getUserById: async (id) => {
    try {
      const response = await api.get(`/User/GetUserById/${id}`);
      console.log(response);
      const { status, resultData } = response.data;

      if (status) {
        return resultData;
      } else {
        console.error('Failed to fetch user list');
        return null;
      }
    } catch (error) {
      console.error('Error fetching user list:', error.message);
      return null;
    }
  },

  addUpdateUser: async (values) => {
    try {
      const response = await api.put(`/User/AddUpdateUser`, values);
      console.log(response);
      const { status, resultData } = response.data;

      if (status) {
        return resultData;
      } else {
        console.error('Failed to update user');
        return null;
      }
    } catch (error) {
      console.error('Error updating user:', error.message);
      return null;
    }
  },

  deleteUser: async (id) => {
    try {
      const response = await api.delete(`/User/DeleteUser?id=${id}`);
      console.log(response);
      const { status, resultData } = response.data;

      if (status) {
        return resultData;
      } else {
        console.error('Failed to delete user');
        return [];
      }
    } catch (error) {
      console.error('Error deleting user:', error.message);
      return [];
    }
  },

  changePassword:(changePassword)=>{
    debugger;
    const request = api.put('/User/ChangePassword',changePassword)
    return request.then((response)=>{
        return response.data
    })
 },

};

export default userApi;
